import { useEffect, useState } from "react";
import {
  configureFirstIframe,
  getLayoutDirection, getPaymentStatusStatus,
  isMobileApp,
  reloadOnBrowserBack } from
"../../utils/util";
import { getMedicalReport, getMedicalReportAppointmentData, getUserDetails } from "../../services/epic/medicalReport";
import { fetchTranslationData } from "../../services/translation/translation";
import { MedicalReportStatus, ServiceTranslation, SlamaRequestTypes } from "../../utils/constants";
import { Loader } from "../../common/Loader";
import Warning from "../common/Warning";
import MedicalReportCard from "./MedicalReportCard";
import UserSpecificCard from "./UserSpecificCard";
import MedicalReportRequestDashboard from "./MedicalReportRequestDashboard";
import RequestMedicalReport from "./RequestMedicalReport";
import WarningInfo from "../../common/WarningInfo";

const MedicalReportWeb = () => {
  const [medicalReport, setMedicalReport] = useState([]);
  const [userDetails, setUserDetails] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [step, setRequestStep] = useState(-1);
  const [translationMap, setTranslationMap] = useState(null);
  const [mrnValue, setMrnValue] = useState();
  const [specialty, setSpecialty] = useState();
  const [medicalReportErrordMsg, setMedicalReportErrordMsg] = useState();
  const [medicalReportLoading, setMedicalReportLoading] = useState(true);
  const [userDetailsLoading, setUserDetailsLoading] = useState(true);
  const [translationLoading, setTranslationLoading] = useState(true);
  const [medicalReportAppointmentData, setMedicalReportAppointmentData] = useState([]);
  const [isLoadingMedicalReport, setIsLoadingMedicalReport] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [showCardDownLoadSuccess, setShowCardDownLoadSuccess] = useState(false);
  const [showInitatedPopUp, setShowInitatedPopUp] = useState(false);
  const [exceptionError, setExceptionError] = useState(false);
  const [errorHeading] = useState("");
  const [errorSubHeading] = useState("");
  // let status = getItemWithExpiry("slaPaymentStatus");
  const [status, setStatus] = useState("");

  useEffect(() => {
    window.parent.scrollTo(0, 0);
    reloadOnBrowserBack();
    setStatus(getPaymentStatusStatus(SlamaRequestTypes.medicalReportRequest));
  }, []);

  const dateConvert = (dateString) => {
    // console.log("DateString", dateString)
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric"
    });
  };

  useEffect(() => {
    window.parent.scrollTo(0, 0);
  }, [step]);


  useEffect(() => {
    // First, fetch user details
    getUserDetails().then((result) => {
      // console.log("User details result >>", result);
      setUserDetails(result.data);
      setMrnValue(result?.data?.patientMRN);
      setUserDetailsLoading(false);

      setMedicalReportLoading(true);
      //calling medical report data
      loadMoreMedicalReport();
      setIsLoading(true);
      getMedicalReportAppointmentData().then((result) => {
        // console.log("AppointmentData  Result ", result);
        if (result) {
          // console.log("resultData >>>>>>", resultData)

          setMedicalReportAppointmentData(result?.data);
          setIsLoading(false);

        }
      }).catch(() => {
        setIsLoading(false);
      });

    }).catch(() => {
      setIsLoading(false);
    });

    // Fetch translation data
    fetchTranslationData(ServiceTranslation.MedicalReport).then((result) => {
      setTranslationMap(result);
      setTranslationLoading(false);
    });

    window.parent.scrollTo(0, 0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!medicalReportLoading && !userDetailsLoading && !translationLoading) {
      setIsLoading(false);
    }
  }, [medicalReportLoading, userDetailsLoading, translationLoading]);

  if (isLoading) {
    return <Loader />;
  }

  function handleLoadMoreClick() {
    loadMoreMedicalReport();
    configureFirstIframe(500, 300);
  }

  function loadMoreMedicalReport() {
    const ITEMS_PER_PAGE = 3;
    if (isLoadingMedicalReport || !hasMore) return;
    setIsLoadingMedicalReport(true);
    getMedicalReport(currentPage).then((result) => {
      const fetchedData = result.data.items || [];
      if (fetchedData.length < ITEMS_PER_PAGE) {
        setHasMore(false);
      }
      fetchedData.forEach((item) => {

        if (item?.medicalReportStatus?.toUpperCase() === MedicalReportStatus.initiated) {
          setShowInitatedPopUp(true);
        }
      });
      setMedicalReport((prev) => [...prev, ...fetchedData]);
      setCurrentPage((prev) => prev + 1);
    }).catch((error) => {
      console.error("Error fetching medical reports:", error);
    });
    setIsLoadingMedicalReport(false);
  }

  return (
    <>
            {exceptionError &&
      <WarningInfo
        setError={setExceptionError}
        alert_text={
        errorHeading
        }
        number_text={
        errorSubHeading
        } />

      }
            {step === -1 &&
      <div className={`${getLayoutDirection()} custombody_color`}>
                    <section className="w-100 clearfix MedicalReportMainSection" id="CoverPlanActive">
                        <div className="container customContainer">
                            {!isMobileApp() &&
            <div className="Title_Inner_Box">
                                    <h6 className="MainTitleOne">{translationMap?.medicalReportDetails}</h6>
                                </div>
            }
                            <div className="cover_inner_wrapper">
                                <div className="cover_main_box1">

                                    {showInitatedPopUp &&
                <Warning
                  desc={translationMap?.payment_waiting_message}
                  heading={translationMap?.waitingPaymentConfirmation} />

                }

                                    {status ?
                status === "cancelled" &&
                <div
                  className="AlertInnerBox YellowAlertInnerBox alert alert-dismissible fade show">
                                                <button
                    type="button"
                    className="close"
                    data-dismiss="alert"
                    aria-label="Close">
                    
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                                                        <path
                        d="M17 7L7 17M7 7L17 17"
                        stroke="#002F70"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      
                                                    </svg>
                                                </button>
                                                <div className="Icon_box">
                                                <span className="material-symbols-outlined" role="img"
                    aria-label="Warning">
                                                    warning
                                                </span>
                                                </div>
                                                <div className="alert_text">
                                                    <h6>{translationMap?.medicalReportpaymentCancel}</h6>
                                                    <p className="number_txt">{translationMap?.pleaseTryAgain}</p>
                                                </div>
                                            </div> :


                null}

                                    {showCardDownLoadSuccess &&
                <div
                  className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                                            <button type="button" className="close" data-dismiss="alert">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                        d="M17 7L7 17M7 7L17 17"
                        stroke="#002F70"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      
                                                </svg>
                                            </button>
                                            <div className="Icon_box">
                                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                <a href="javascript:void(0);">
                                                <span className="material-symbols-outlined">
                                                    check_circle
                                                </span>
                                                </a>
                                            </div>
                                            <div className="alert_text">
                                                <h6>
                                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                    <a href="javascript:void(0);">
                                                        {translationMap?.downloadSuccess}
                                                    </a>
                                                </h6>
                                            </div>
                                        </div>

                }

                                    {medicalReport && medicalReport.length > 0 ?
                <>
                                            <p className="Gray_Title">
                                                {translationMap?.showing} {medicalReport.length} {translationMap?.results}
                                            </p>
                                            <div className="medical_main_inner_wrapper">
                                                {medicalReport.map((medicalReport, index) =>
                    <MedicalReportCard
                      key={index}
                      medicalReport={medicalReport}
                      translationMap={translationMap}
                      setShowCardDownLoadSuccess={setShowCardDownLoadSuccess}
                      showCardDownLoadSuccess={showCardDownLoadSuccess} />

                    )}
                                            </div>
                                            <div className="Load_More_Btn_Box">
                                                {hasMore ?
                    <div>
                                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                        <a
                        // eslint-disable-next-line no-script-url
                        href="javascript:void(0);"
                        onClick={handleLoadMoreClick}
                        className={`load_more_link ${isLoading ? "disabled" : ""}`}>
                        
                                                            {isLoadingMedicalReport ? "Loading..." : translationMap?.loadMoreResults}
                                                        </a>
                                                    </div> :
                    null}
                                                <div className="Gray_Title" style={{ display: 'flex', gap: '3px' }}>
                                                    <p className="Gray_Title"> {translationMap?.showingResultsSince} </p>
                                                    <p className="Gray_Title"
                      style={{ direction: 'ltr' }}>
                                                        {dateConvert(medicalReport[medicalReport.length - 1].requestDate)}
                                                    </p>
                                                </div>
                                            </div>
                                        </> :

                <div className="AlertInnerBox YellowAlertInnerBox2">
                                            <div className="Icon_box">
                                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                <a href="javascript:void(0);">
                                                    <span className="material-symbols-outlined">
                                                        info
                                                    </span>
                                                </a>
                                            </div>
                                            <div className="alert_text">
                                                <h6>
                                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                    <a href="javascript:void(0);">
                                                        {translationMap?.noMedicalReportToDisplay}
                                                    </a>
                                                </h6>
                                            </div>
                                        </div>


                }

                                    {medicalReportErrordMsg &&

                <div className="AlertInnerBox YellowAlertInnerBox fade show">
                                            <div className="Icon_box">
                                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                <a href="javascript:void(0);">
                                                    <span className="material-symbols-outlined">info</span>
                                                </a>
                                            </div>
                                            <div className="alert_text">
                                                <h6>
                                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                    <a href="javascript:void(0);">
                                                        <span className="material-symbols-outlined">info</span>
                                                    </a>
                                                </h6>
                                            </div>
                                            <div className="alert_text">
                                                <h6>
                                                    <span>{medicalReportErrordMsg}</span>
                                                </h6>
                                            </div>
                                        </div>

                }


                                </div>
                                <div className="cover_main_box2">
                                    {userDetails &&
                <UserSpecificCard setRequestStep={setRequestStep} userDetails={userDetails}
                translationMap={translationMap} />}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
      }
            {step === 0 &&
      <MedicalReportRequestDashboard
        setRequestStep={setRequestStep}
        step={step}
        translationMap={translationMap}
        medicalReportAppointmentData={medicalReportAppointmentData}
        userDetails={userDetails} />

      }
            {step === 1 &&
      <RequestMedicalReport
        setRequestStep={setRequestStep}
        userDetails={userDetails}
        medicalReport={medicalReport}
        translationMap={translationMap}
        mrnValue={mrnValue}
        setMrnValue={setMrnValue}
        specialty={specialty}
        setSpecialty={setSpecialty}
        medicalReportErrordMsg={medicalReportErrordMsg}
        setMedicalReportErrordMsg={setMedicalReportErrordMsg}
        medicalReportAppointmentData={medicalReportAppointmentData}
        step={step} />

      }
        </>);


};
export default MedicalReportWeb;